import React, { useState, useMemo } from "react";
import moment from "moment";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import ALoader from "views/pages/manage/common/a-loader";
import ChequeDetails from "./ChequeDetails";
import { useUpdateChequeStatus } from "../hooks/useUpdateChequeStatus";
import "../styles/depositChequeForm.scss";
import { getFormatedDate } from "views/pages/manage/unAssigned/concessionApproval/common";

const inputHeight = "44px";
const textInputStyle = { height: inputHeight, borderRadius: "4px" };
// Expanded Dropdowns
const reasons = [
  { label: "Left", value: "LEFT" },
  { label: "Transfer Out", value: "TRANSFER_OUT" },
  { label: "Payment Mode Change", value: "PAYMENT_MODE_CHANGE" },
  { label: "Others", value: "OTHERS" },
];

const ChequeDateExtensionForm = ({
  row,
  refreshList = () => {},
  config = {
    bounceDayLimit: 5,
    restrictedStatuses: ["IBTR", "CRCG", "STCG", "DISC"],
  },
}) => {
  const [form, setForm] = useState({
    reason: null,
    remarks: "",
    extensionDays: "",
  });

  const { updateChequeStatus, isLoading } = useUpdateChequeStatus({
    isChequeDateExtension: true,
  });

  const rowFormHandler = (value, key) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const onRefreshList = (response) => {
    const data = {
      totalReceipts: 1,
      ...row
    };
    const updatedRow = {
      ...row,
      newPaymodeDate: moment(row.paymodeDate)
        .add(Number(form.extensionDays), "days")
        .toISOString(),
    };

    refreshList(data, updatedRow, "DATE_EXTENSION");
  };

  const handleConfirm = () => {
    const requestPayload = {
      psid: row.psid,
      referenceNumber: row.referenceNumber,
      daysExtended: Number(form.extensionDays),
      remarks:
        form.reason?.value === "OTHERS" ? form.remarks : form.reason?.value,
    };

    updateChequeStatus(requestPayload, onRefreshList);
  };

  const isOtherSelected = form.reason?.value === "OTHERS";
  const dropdownItems = reasons;

  return (
    <div className="deposit-form">
      {isLoading && <ALoader />}

      <ChequeDetails
        psid={row.psid}
        chequeNumber={row.referenceNumber}
        chequeAmount={row.amountCollected}
        chequeDate={getFormatedDate(row.paymodeDate)}
      />

      <div className="mt-4">
        <AInput
          value={"Date Extension"}
          label="Status"
          style={textInputStyle}
          disabled={true}
        />

        <AInput
          value={form.extensionDays}
          label="Enter extension days"
          style={textInputStyle}
          minLength={1}
          type="number"
          placeholder="Enter number of days"
          handler={(value) => rowFormHandler(value, "extensionDays")}
        />

        <AAutoComplete
          label="Reason"
          currentValue={form.reason}
          handleChange={(value) => rowFormHandler(value, "reason")}
          items={dropdownItems}
          height={inputHeight}
          isMulti={false}
        />

        {isOtherSelected && (
          <AInput
            value={form.remarks}
            label="Remarks"
            placeholder="Enter remarks (Mandatory)"
            style={{ height: inputHeight, borderRadius: "4px" }}
            handler={(value) => rowFormHandler(value, "remarks")}
          />
        )}
      </div>

      <div className="mt-3">
        <AButton
          className="no-ml-btn"
          variant="primary_filled"
          updatedStyle={{ width: "100%" }}
          disabled={
            !form.reason ||
            (isOtherSelected && !form.remarks) ||
            !form.extensionDays
          }
          onClick={handleConfirm}
        >
          Send for approval
        </AButton>
      </div>
    </div>
  );
};

export default ChequeDateExtensionForm;
